<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-user-edit"></i>&nbsp;<ng-container i18n>Edit Additional Guests</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex align-items-center gap-3">
    <div class="flex-fill"></div>
    <app-select-search
      bindLabel="name"
      bindValue="id"
      [inline]="true"
      (search)="guestSearch.next($event)"
      [items]="guests$ | async"
      [ctrl]="form.get('guestIds')"
      i18n-placeholder
      placeholder="Add Existing Guest"
      class="w-50"
    ></app-select-search>
    <button
      (click)="onAddExisting()"
      [disabled]="form.get('guestIds').value?.length === 0"
      i18n-matTooltip
      matTooltip="Add selected guest"
      type="button"
      class="btn btn-secondary-info"
    >
      <span class="far fa-plus"></span> <ng-container i18n>add</ng-container>
    </button>

    <button
      (click)="onNew()"
      i18n-matTooltip
      matTooltip="Create new guest and add to this inquiry"
      type="button"
      class="btn btn-secondary-info"
    >
      <span class="far fa-plus"></span> <ng-container i18n>create new</ng-container>
    </button>
  </div>

  <div class="table-holder table-responsive mt-3">
    <table class="table table-default table-striped">
      <mat-table #table matSort matSortActive="departure" matSortDirection="desc" [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <ng-container i18n>Guest Name</ng-container></mat-header-cell
          >
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="element.name" matTooltipPosition="above">
              {{ element.name | truncate : 25 }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="primaryEmail">
          <mat-header-cell *matHeaderCellDef mat-sort-header> <ng-container i18n>Email</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="element.primaryEmail" matTooltipPosition="above">
              {{ element.primaryEmail | truncate : 25 }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef> <ng-container i18n>Telephone</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="element.phone" matTooltipPosition="above">
              {{ element.phone | truncate : 25 }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="countryView">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <ng-container i18n>Country</ng-container></mat-header-cell
          >
          <mat-cell *matCellDef="let element"> {{ element.countryView }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef> <ng-container i18n>Edit</ng-container></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div dropdown placement="bottom right" container="body">
              <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
                <a class="btn-ellips">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
              </div>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <li>
                  <button (click)="onRemove(element)" type="button">
                    <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Remove</ng-container>
                  </button>
                </li>
              </ul>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator2
        #paginator
        [length]="dataSource?.data?.length"
        [class.hidden]="isEmptyTable$ | async"
        [pageSize]="5"
        [pageSizeOptions]="[5, 10, 20, 50, 100]"
        [showFirstLastButtons]="true"
      >
      </mat-paginator2>
    </table>
    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-secondary-info">
    <i class="far fa-check"></i> <ng-container i18n>done</ng-container>
  </button>
</div>
